/**
* This page displays a summary of all funds under administration
*
* Created by Paul on 1/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'
import NumberFormat from 'react-number-format'

// action import
import { ActionCreator } from '../../actions/'

// component import
import SimpleLoader from '../../components/SimpleLoader/'
import FundList from '../../components/FundList/'
import Fund from '../../components/Fund/'
import FundAdd from '../../components/FundAdd/'
import FundOverview from '../../components/FundOverview/'
import FundActions from '../../components/FundActions/'
import FundDocuments from '../../components/FundDocuments/'
import FundMembers from '../../components/FundMembers/'
import FundContributions from '../../components/FundContributions/'

import Tester from '../../components/Tester/'

// Configurations
import config from '../../config'
import constants from '../../constants'

import { FaArrowLeft } from "react-icons/fa";

// style import
import './style.scss'


class Funds extends Component {

    constructor(props) {
        super(props)
        this.state = { currentComponent: constants.LIST, currentFundTab: constants.OVERVIEW }
        this.handleStateChange = this.handleStateChange.bind(this)
        this.handleFundNav = this.handleFundNav.bind(this)
    }

    componentDidMount() {
        const { getFundsListData } = this.props
        getFundsListData()
    }

    handleStateChange(state, fund) {

        if (state === constants.VIEW_FUND && (fund.fund_status === 'In Progress' || fund.fund_status === 'In Review')) {
            state = constants.CREATE_FUND
        }

        this.setState({
            currentComponent: state,
            fund: fund
        })
    }

    handleFundNav(newTab) {
        this.setState({
            currentFundTab: newTab
        })
    }

    render() {
        
        const { fundsSummaryData } = this.props
        
        return (
            
            <div className="funds main-wrapper">
                
                { this.state.currentComponent == constants.LIST &&

                    <div className="main-container main-container__summary">

                        <h3>Funds Summary</h3>

                        <div className="funds__summary">
                            <div className="funds__summary--column">
                                <span className="title">Active Funds:</span>
                                <span className="value">{ fundsSummaryData['number_of_funds'] }</span>
                            </div>
                            <div className="funds__summary--column">
                                <span className="title">Funds In Progress:</span>
                                <span className="value">{ fundsSummaryData['funds_in_progress'] }</span>
                            </div>
                            <div className="funds__summary--column">
                                <span className="title">Total FUA ($):</span>
                                <span className="value"><NumberFormat value={ fundsSummaryData['fua'] } displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                            </div>
                        </div>

                    </div> }

                {/* this.state.currentComponent == constants.VIEW_FUND &&

                    <div className="main-container main-container__summary">

                        <h3>{ this.state.fund.fund_name }</h3>
                        
                        <FundNav handleFundNav={ this.handleFundNav } fund={ this.state.fund } />

                    </div>
                */}

                { this.state.currentComponent === constants.CREATE_FUND && <FundAdd fund={ this.state.fund } /> }

                { this.state.currentComponent === constants.LIST && <FundList handleStateChange = { this.handleStateChange } /> }
                
                {/* this.state.currentComponent == constants.VIEW_FUND && this.state.currentFundTab == constants.OVERVIEW &&
                    <FundOverview fund={ this.state.fund } />
                }

                { this.state.currentComponent == constants.VIEW_FUND && this.state.currentFundTab == constants.ACTIONS &&
                    <FundActions fund={ this.state.fund } />
                }

                { this.state.currentComponent == constants.VIEW_FUND && this.state.currentFundTab == constants.DOCUMENTS &&
                    <FundDocuments fund={ this.state.fund } />
                }

                { this.state.currentComponent == constants.VIEW_FUND && this.state.currentFundTab == constants.MEMBERS &&
                    <FundMembers />
                }

                { this.state.currentComponent == constants.VIEW_FUND && this.state.currentFundTab == constants.CONTRIBUTIONS &&
                    <FundContributions fund={ this.state.fund } />
                */}

            </div>
        )
    }
}

// define the prop types
Funds.propTypes = {
    isLoading: PropTypes.bool,
    fundsSummaryData: PropTypes.object,
    fundsListData: PropTypes.array,
    goToRoute: PropTypes.func.isRequired,
}

const mapStateToPros = (state) => {
    return {
        isLoading: state.fundsSummaryState.isLoading,
        fundsSummaryData: state.fundsSummaryState.fundsSummaryData,
        fundsListData: state.fundsSummaryState.fundsListData
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundsListData: action.getFundsListData,
        goToRoute: action.goToRoute
    }
}


export default connect(mapStateToPros,mapDispatchToProps)(Funds)



// WEBPACK FOOTER //
// ./src/pages/Funds/index.js